export default {
    name: 'comment-block',
    data: () => ({
    }),
    props: {
        selected: Object
    }
};
